import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "primary--text ml-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_subheader = _resolveComponent("v-subheader")!
  const _component_ChildrenAttendanceList = _resolveComponent("ChildrenAttendanceList")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_ctx.attendanceClass && _ctx.childrenClass && _ctx.chatSummary)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_subheader, { class: "attendance-list-header" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.clas.className) + " ", 1),
            (_ctx.myClass && _ctx.myClass.classId === _ctx.clas.classId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('attendance.inCharge')), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_v_spacer),
            _createTextVNode(" " + _toDisplayString(_ctx.chatSummary.presentChildrenCount) + "/" + _toDisplayString(_ctx.chatSummary.totalChildrenCount), 1)
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childrenClass.children, (child, index) => {
          return (_openBlock(), _createBlock(_component_v_list_item, {
            key: index,
            to: `/communication/chat/${child.childId}`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ChildrenAttendanceList, {
                child: child,
                attendanceClass: _ctx.attendanceClass,
                chatSummary: _ctx.chatSummary
              }, null, 8, ["child", "attendanceClass", "chatSummary"])
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}